export const PROJECTS = [
  {
    slug: "nord",
    heroMobile: { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/1nf85vhg_NORD%20mobile%20version.png", w: 900, h: 1600, alt: "NORD, modern lodge in misty forest with fire pit at dusk" },
    title: "NORD",
    year: "TBD",
    location: "Pacific Northwest",
    country: "United States",
    size: "139+ Acres",
    projectType: "Destination Resort",
    status: "Concept / Masterplan Complete",
    role: "Concept · Masterplan · Architecture Direction · Brand · Narrative · Wellness Concept",
    tag: "Destination Resort",
    story:
      "Nordic design frames the raw landscape, a dialogue between shelter and exposure through architectural language rooted in local geology.",
    fullCopy: [
      "NORD is where Nordic design frames the raw landscape, revealing the dialogue between shelter and exposure through architectural language rooted in local geology. This is not about adding to the landscape. It is about revealing what is already there. We design for the climate, not against it.",
      "NORD is a destination resort concept that rejects the resort category. No golf courses. No sprawling amenities competing for attention. Instead: trails, thermal baths, glass and charred timber structures that defer to the environment.",
      "Originally conceived for a 139-acre site on the Oregon coast, positioned between two established vacation destinations, the framework is adaptable, whether as a full-scale destination resort with 150+ units, wellness center, restaurant, and town center; a boutique cabin retreat with 10–20 units in a remote, high-impact setting for intimate exclusivity; or a hybrid model with phased development starting small and expanding with demand.",
    ],
    images: [
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/l6ranvc5_wildaniels_Match_beams_to_the_rest_of_the_roofs_exterior_desi_df0fa129-c069-4340-bc95-ad8693dfc8ab_0.png",
        w: 1456,
        h: 816,
        alt: "NORD, charred timber pavilion nested in Pacific Northwest forest with boulders and understory",
        caption: "The pavilion, charred timber, glass, geology.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/vs6tt563_midjourney-editor-1787605220659.png",
        w: 1456,
        h: 816,
        alt: "NORD, cabin bedroom with blackened steel hearth, low platform bed and floor-to-ceiling forest windows",
        caption: "The interior, warmth held against wild timber.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/z4ikzy3t_wildaniels_remove_wall_pictures_plant_on_coffee_table_seat_cu_f4c9915c-1822-4d87-bfa5-48c6f5b7e8ba_2.png",
        w: 1456,
        h: 816,
        alt: "NORD, communal lounge with dark timber, stone hearth, low banquettes and lake-facing glazing",
        caption: "The lounge, timber, stone, long horizon.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/ibwrgrx3_wildaniels_Ultra-high-end_architectural_photography_of_an_int_3ff03a7d-ceb4-4859-9e02-701ea9ecff66_1.png",
        w: 1456,
        h: 816,
        alt: "NORD, cabin bedroom with blackened steel hearth, low platform bed and floor-to-ceiling forest windows",
        caption: "The bedchamber, shelter framed by wilderness.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/ipllcugx_wildaniels_editorial_photograph_of_an_epic_high_end_design_sa_222bcd33-2aff-4103-925a-724acff9267c_2.png",
        w: 1024,
        h: 1024,
        alt: "NORD, ceremonial fire hall with conical blackened hood, circular hearth and continuous banquette",
        caption: "The fire hall, a circle held around flame.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/3wkbgsiu_wildaniels_Cinematic_architectural_photography_of_a_modern_lo_14cfc93a-9748-4f5e-8ed8-5304ace19406_3.png",
        w: 1232,
        h: 928,
        alt: "NORD, timber lodge at dusk with fire pit clearing in old-growth forest",
        caption: "The clearing, hearth, mist, quiet.",
      },
    ],
  },
  {
    slug: "tungsten",
    heroMobile: { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/ydw3l3l1_TUNGSTEN%20mobile%20version.jpeg", w: 900, h: 1600, alt: "TUNGSTEN, lava rock hearth with mounted stag and candles" },
    title: "TUNGSTEN",
    year: "2023",
    location: "Mt. Hood, OR",
    country: "United States",
    size: "3 Story · 7 Bed · 3 Bath · 2 Kitchen",
    projectType: "Mountain Lodge",
    status: "Completed",
    role: "Concept · Interior · Brand · Narrative · Acquisition",
    tag: "Mountain Lodge",
    story:
      "A design-forward mountain lodge where nostalgic ski-chalet vibes meet the modern amenities we'd be lost without.",
    fullCopy: [
      "Tungsten Lodge is a design-forward mountain lodge where nostalgic ski-chalet vibes meet the modern amenities we'd be lost without. Tungsten wasn't built from the ground up, it was reimagined. A three-story mid-century property in Government Camp, steps from the slopes, ski-in ski-out, with seven bedrooms, two fireplaces, and two full kitchens. The bones were there; we brought the soul.",
      "The design honored simpler times, vintage ski memorabilia, curated vinyl, wood-burning fireplaces, while embracing what we'd be lost without: Nordic sauna, cold plunge, small-batch coffee, premium grooming amenities, and spaces designed for both gathering and retreat. Fire as anchor. Whether around the three-story lava rock chimney or the outdoor pit under old-growth trees, the lodge was built for connection and recharge. Mid-century silhouettes meet heavy-duty weather shielding, with interiors that prioritize the hearth as narrative anchor through stone, steel, and Douglas Fir, balancing nostalgia with function.",
      "Tungsten Lodge was successfully acquired, reimagined and exited, proving the model works. The concept, design approach, and brand strategy are now available for reimagining in other alpine markets.",
    ],
    images: [
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/6yclj5wq_IMG_5479%204.webp",
        w: 2016,
        h: 1512,
        alt: "Tungsten Lodge, three-story lava rock chimney with mounted stag, candle mantel and blackened shou-sugi-ban wall against Douglas Fir ceilings",
        caption: "The hearth, three stories of lava rock.",
      },
      {
        src: "/generated/tungsten_sauna.jpg",
        w: 2656,
        h: 1600,
        alt: "Tungsten Lodge, outdoor sauna clad in shou-sugi-ban charred timber, blackened steel chimney and warm amber window glow, sited in an alpine clearing at Government Camp with Mt. Hood in the distance",
        caption: "The sauna, charred timber, alpine hush.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/p03cjvd3_IMG_1102.jpg",
        w: 1500,
        h: 1250,
        alt: "Mt. Hood at first light, snow-capped alpine peak in golden hour above Government Camp",
        caption: "Mt. Hood, the site, the reason, the north star.",
      },
      {
        src: "/generated/tungsten_ski.jpg",
        w: 2656,
        h: 1600,
        alt: "Tungsten Lodge, vintage ski memorabilia: hand-carved wooden skis, aged leather boots, bamboo poles, coiled rope and canvas duffel arranged against reclaimed timber",
        caption: "The memorabilia, simpler times, honoured.",
      },
    ],
  },
  {
    slug: "companeros",
    heroMobile: { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/y7jjoxus_COMPANEROS%20mobile%20version%20.png", w: 900, h: 1600, alt: "COMPAÑEROS, cliffside restaurant terrace overlooking the valley" },
    title: "COMPAÑEROS",
    year: "TBD",
    location: "Eje Cafetero / Coffee Region",
    country: "Colombia",
    size: "Undisclosed",
    projectType: "Boutique Resort",
    status: "In Development",
    role: "Concept · Narrative · Cultural Direction · Interior · Brand · Programming",
    tag: "Boutique Resort",
    story:
      "Hospitality anchored in ritual, tradition and the land itself, where coffee isn't consumed, it's understood.",
    fullCopy: [
      "Compañeros is a boutique retreat in Colombia's coffee region, the Eje Cafetero, where coffee isn't just consumed, it's understood. This is hospitality anchored in ritual, tradition, and the land itself.",
      "We're creating an experience that honors the local culture without performing it. Guests don't observe coffee production from a distance, they participate, understanding why altitude matters, how fermentation affects flavor, and what generations of knowledge taste like.",
      "This is not a plantation hotel. It is an immersive cultural experience disguised as lodging.",
    ],
    images: [
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/4n35eiko_wildaniels_sleek_railing_with_lush_landscaping_with_symmetry__04cd8929-c545-4ce1-9781-8c4801c1a6ce_1.png",
        w: 1456,
        h: 816,
        alt: "Compañeros, cantilevered concrete-and-stone terrace restaurant perched above the Andean coffee valley at dusk",
        caption: "The perch, table set for the region.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/2gxeio17_wildaniels_httpss.mj.runraxlzf5TScA_Exterior_photograph_of_a__eebbabfa-9e2b-4913-9b80-92a48e2bc9c9_1.png",
        w: 1456,
        h: 816,
        alt: "Compañeros, infinity pool cut into the hillside overlooking the misted cloud-forest canopy of the Eje Cafetero",
        caption: "The pool, cut into the cloud forest.",
      },
      {
        src: "/generated/companeros_bedchamber.jpg",
        w: 2740,
        h: 1536,
        alt: "Compañeros, board-formed concrete bedchamber with low platform bed, timber block plinths and window framing the coffee mountains",
        caption: "The bedchamber, concrete framing the mountains.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/s0sdoz6u_wildaniels_interior_photograph_of_a_high_end_boutique_hotel_g_4dff0367-6b26-4526-b808-629fce31eba1_2.png",
        w: 1456,
        h: 816,
        alt: "Compañeros, poured-concrete bathroom with monolithic river-stone vessel sink, timber ledge and floor-to-ceiling window onto the jungle",
        caption: "The bath, stone, water, jungle.",
      },
    ],
  },
  {
    slug: "shopdog",
    heroMobile: { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/n3jmnw1t_SHOPDOG%20mobile%20version.png", w: 900, h: 1600, alt: "SHOP DOG, glass block window over a walnut console" },
    title: "SHOP DOG",
    year: "2025",
    location: "Detroit, MI",
    country: "United States",
    size: "11,300 SQ FT",
    projectType: "Headquarters",
    status: "Completed",
    role: "Acquisition · Interior · Adaptive Reuse",
    tag: "Headquarters",
    story:
      "A century-old machine shop reimagined as an incubator for hospitality, connection, creativity, and our work. This is where HANKDAVID is anchored.",
    fullCopy: [
      "Shop Dog is a century-old machine shop reimagined as an incubator for hospitality, connection, creativity, and our work. This is where HANKDAVID is anchored.",
      "Built in 1922 as a machine shop manufacturing crankshafts, the fully renovated space now serves as our headquarters and creative outpost. The building retains its distinctive barrel-shaped roof and industrial bones, exposed brick, high ceilings, and steel windows, while housing the studio where we envision, ideate, and develop our hospitality concepts.",
      "We are proud to be the current stewards of this historically rich and textured piece of Detroit.",
    ],
    images: [
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/pr3ltv58_7a3a9c7b-7146-458f-a159-21dd0ea0cec0.jpg.webp",
        w: 2000,
        h: 1200,
        alt: "Shop Dog, long dark walnut console beneath glass-block window, turntable, curated books and globe lamp against exposed brick",
        caption: "The console, glass block, brick, quiet ceremony.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/3rkjqxhf_050-5137%20Trumbull-46.webp",
        w: 2000,
        h: 1200,
        alt: "Shop Dog, creative studio with drafting table, Muhammad Ali print, industrial steel windows, sage lockers and vintage gas pump",
        caption: "The studio, where the concepts are drawn.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/89q82rjs_054-5137%20Trumbull-50.webp",
        w: 2000,
        h: 1200,
        alt: "Shop Dog, communal lounge with wall-length walnut cabinetry, sectional, exposed timber beams and glass-block clerestory",
        caption: "The lounge, walnut wall, communal gravity.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/rwu2o8td_031-5137%20Trumbull-27.webp",
        w: 2000,
        h: 1200,
        alt: "Shop Dog, corridor with Harland Miller artwork, distressed painted brick and hexagonal mosaic tile floor under warm sconce light",
        caption: "The corridor, Harland Miller, mosaic, warm light.",
      },
    ],
  },
  {
    slug: "monolith",
    heroMobile: { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/1i9ftwyl_MONOLITH%20HERO%20mobile%20version.png", w: 900, h: 1600, alt: "MONOLITH, thermal pool hall atrium with skylights and hanging ferns" },
    title: "MONOLITH",
    year: "2027",
    location: "Detroit, MI",
    country: "United States",
    size: "23,000 SQ FT",
    projectType: "Social Wellness Club",
    status: "In Development",
    role: "Concept · Wellness Direction · Interior · Adaptive Reuse · Brand · Narrative",
    tag: "Social Wellness Club",
    story:
      "A social wellness club designed for recalibration and connection, a thermal circuit of heat, cold, silence and sound.",
    fullCopy: [
      "Monolith is a social wellness club designed for recalibration and connection, connection to yourself, your surroundings, and your community. The thermal circuit is an intentional loop of heat, cold, and rest: tepidarium, caldarium, cold plunge, sauna, and steam, self-guided or facilitated with Aufguss ceremonies and guided breathwork. As designed, it is not passive relaxation. It is active restoration.",
      "Social spaces with dedicated zones for conversation include soaking pools, restaurant and bar, and communal lounges, but we also protect silence. Our audio listening bars are \"slow listening\" sanctuaries: no conversation, only analog sound through tube-amplified systems in acoustically tuned rooms. Network over bone broth or disappear with a record and Japanese whisky. Both are equally valued.",
      "The wellness component is curated. There is a gym, but through the lens of intentional, advanced wellness. This is not gym culture. This is not spa culture. It is a space where the contrast between performance and recovery is treated with strategy and presence.",
    ],
    images: [
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/d3xy6vw7_MONOLITH%20laptop%20version.webp",
        w: 2000,
        h: 1125,
        alt: "Monolith, thermal pool hall with skylights, basalt wall and reclining lounge chairs",
        caption: "The thermal hall, pools, rest and light.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/y6ps7iw0_wildaniels_httpss.mj.runOO_y97SeX3M_httpss.mj.runfI6J-NRhxD0__e2c36064-7f00-48c7-8803-534c54855b0f_2.png",
        w: 1456,
        h: 816,
        alt: "Monolith, communal lounge with olive banquettes and rosewood bar",
        caption: "The lounge, a place to gather.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/icvkgoyl_wildaniels_httpss.mj.runbk-n6b_GQGw_interior_photograph_of_an_70b893ee-75ed-4842-a1f3-8bc8ac5db4bd_1.png",
        w: 1232,
        h: 928,
        alt: "Monolith, analog listening bar with vinyl library and tube amplification",
        caption: "The listening bar, slow listening, in analog.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/7mcekott_wildaniels_httpss.mj.run62CYsLizTgo_httpss.mj.runp2qKuoVYwmk__769f42dc-5e0d-4811-b2c8-c5b2dd90ebd2_3.png",
        w: 1024,
        h: 1024,
        alt: "Monolith, cedar sauna interior with basalt hearth",
        caption: "The sauna, cedar, basalt, breath.",
      },
    ],
  },
  {
    slug: "wolfram",
    heroMobile: { src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/w0tjotok_WOLFRAM%20mobile%20version.png", w: 900, h: 1600, alt: "WOLFRAM, gothic stone estate with arched entry at dusk" },
    title: "WOLFRAM",
    year: "TBD",
    location: "Confidential",
    country: "Undisclosed",
    size: "Undisclosed",
    projectType: "Historic Adaptive-Reuse",
    status: "In Development",
    role: "Concept · Narrative · Interior · Brand · Adaptive Reuse",
    tag: "Historic Adaptive-Reuse",
    story:
      "Gothic estates and historic structures reimagined as immersive hospitality, mood, history, and the ritual of shadow under one roof.",
    fullCopy: [
      "Wolfram reimagines gothic estates and historic structures as immersive hospitality experiences where mood, history, and the ritual of shadow come together under one roof. We target gothic estates, masonic temples, and Victorian structures with architectural gravity, properties that possess inherent drama, the kind of spaces that hold stories in their bones, and transform them into boutique hospitality experiences where guests don't just stay, they inhabit. This is not haunted-house theater. It is atmospheric hospitality rooted in place, history, and the beauty of night.",
      "Check in as daylight fades. The building reveals itself slowly, heavy doors, dim corridors, the flicker of candlelight, leading to suites that are bespoke, layered, designed for retreat with deep leather, velvet curtains, and restored masonry. Evening unfolds in communal spaces: a library lounge with floor-to-ceiling shelves and worn Persian rugs, a speakeasy-style bar serving seasonal cocktails and rare spirits, fireplaces that anchor conversation, and perhaps a solarium catching moonlight or a garden labyrinth for nocturnal wandering.",
      "Morning comes gently with coffee in quiet corners, the contrast of daylight revealing what darkness concealed. This isn't about ghost tours and gimmicks. It's about treating historic properties with reverence while making them financially viable through hospitality that honors their character, where fireside conversation, curated libations, and the embrace of darkness replace the expected hotel experience.",
    ],
    images: [
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/82u16stf_WOLFRAM%20laptop%20version.png",
        w: 2000,
        h: 1125,
        alt: "Wolfram, moody Gothic-Victorian stone estate at dusk with slate rooftops, mullioned windows and lantern-lit archways set against a dark treeline",
        caption: "The estate, architectural gravity, held in shadow.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/41grn1u4_wildaniels_httpss.mj.runEXyNGt00W4s_clean_up_all_of_this_remo_aef680a5-2e7d-4e8c-86a8-9040c53c8620_3.png",
        w: 1456,
        h: 1093,
        alt: "Wolfram, library lounge with cognac tufted-leather chesterfield, brass sconces, a mirrored spirits cabinet and Persian rug",
        caption: "The library lounge, leather, brass, rare spirits.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/4djjwljf_wildaniels_httpss.mj.runqJwwNu6K8Qo_evening_exterior_photogra_909fd2e4-58ba-4f2e-a77e-512ef60246a9_3.png",
        w: 1456,
        h: 1093,
        alt: "Wolfram, formal boxwood labyrinth and stone urns fronting an ivy-clad Gothic manor at dusk with lit lanterns flanking the entry",
        caption: "The garden labyrinth, for nocturnal wandering.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/yn6q4hkk_wildaniels_a_low-light_photograph_of_a_solarium_ultra_photore_cb6b0701-caa0-4176-a273-7925bc81cf6d_3.png",
        w: 2000,
        h: 1125,
        alt: "Wolfram, blackened steel-frame solarium at night with warm interior glow, pendant lanterns and a walled botanical garden",
        caption: "The solarium, catching moonlight.",
      },
    ],
  },
  {
    slug: "kenya-safari-experience",
    confidential: true,
    video: "/videos/kenya-safari-mood.mp4",
    videoDesktop: "/videos/kenya-safari-mood-16x9.mp4",
    heroMobile: {
      src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/jcg3f2p1_wildaniels_httpss.mj.runxdprjoS9s4A_Ultra-cinematic_wildlife__93567a15-c81f-4c84-b834-362f9e2dc198_2.png",
      w: 1456,
      h: 816,
      alt: "A lion in profile, resting in golden savanna grass, Maasai Mara",
    },
    title: "KENYA SAFARI EXPERIENCE",
    year: "TBD",
    location: "Maasai Mara",
    country: "Kenya",
    size: "-",
    projectType: "Confidential",
    status: "Confidential — Coming Soon",
    role: "-",
    tag: "Confidential — Coming Soon",
    story: "A new chapter, taking shape in Kenya's Maasai Mara. Details under wraps.",
    fullCopy: [
      "A new chapter, taking shape in Kenya's Maasai Mara. Details under wraps.",
    ],
    images: [
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/jcg3f2p1_wildaniels_httpss.mj.runxdprjoS9s4A_Ultra-cinematic_wildlife__93567a15-c81f-4c84-b834-362f9e2dc198_2.png",
        w: 1456,
        h: 816,
        alt: "A lion in profile, resting in golden savanna grass, Maasai Mara",
        caption: "Held still, watching.",
      },
      {
        src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_depth-design-studio/artifacts/if0pxhu0_wildaniels_httpss.mj.runzbzImiiA1Cc_Ultra-cinematic_wildlife__7521f309-0686-4987-8951-7a2c4ca27861_3.png",
        w: 928,
        h: 1232,
        alt: "Close detail of zebra stripes in raking light",
        caption: "Pattern, up close.",
      },
    ],
  },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Narrative Primacy",
    lede: "Design isn't an aesthetic, it's a storytelling tool.",
    body:
      "Every element tells a story. We turn the stay into a journey, where the environment is an active participant, not a backdrop.",
  },
  {
    n: "02",
    title: "Provenance of Story",
    lede: "Luxury is a living narrative.",
    body:
      "A property should not simply host a guest, but tell them a story only this location can articulate. We unearth local folklore and historical legacies, and design theatrical journeys where the property becomes the local host.",
  },
  {
    n: "03",
    title: "Intentionality of Design",
    lede: "Evocative design.",
    body:
      "The measure of luxury is found in the harmony of tactile materials, ambient lighting and sensory cues. We reject trend-driven minimalism in favor of legacy reimagined, layered textures, indigenous craft, curated art.",
  },
  {
    n: "04",
    title: "Truth of Place",
    lede: "Radical authenticity.",
    body:
      "The most resonant experiences celebrate their surroundings rather than isolating from them. Place-based design, hyper-local collaboration and vernacular architecture ensure your presence is rooted in the community.",
  },
];
